import api from '@pray/shared/utils/api';

export async function sendTestEmail({
  artistId = undefined,
  templateId = undefined,
  emails = undefined,
  senderId = undefined,
  subject = undefined,
  previewText = undefined,
}) {
  if (!templateId) throw new Error('Email Template Id is required');
  if (!artistId) throw new Error('Artist Id is required');

  const data = {
    emails,
    sender_id: senderId ?? null,
  };
  if (subject !== undefined) data.subject = subject;
  if (previewText !== undefined) data.preview_text = previewText;

  const url = `/web/studio/artists/${artistId}/email-templates/${templateId}/test-email`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
